const Back = "Volver";
const Close = "Cerrar";
const days = "d\xEDas";
const days_abbr = "h";
const Email = "Correo electr\xF3nico";
const hours = "horas";
const minutes = "minutos";
const none = "ninguno";
const seconds = "segundos";
const Terms_default = "Al hacer clic en este enlace, acepta recibir nuestros planes y promociones con fines comerciales. De conformidad con el Reglamento General de Protecci\xF3n de Datos (GDPR), informamos que sus datos se incorporar\xE1n a nuestras bases de datos. Como cliente, puede conocer y acceder libremente a los datos personales bajo nuestro control y ejercer sus derechos como propietario de estos datos de acuerdo con GDPR.";
const Terms_default_label = "T\xE9rminos y condiciones";
const es = {
  "(Optional)": "(Opcional)",
  Back,
  Close,
  days,
  days_abbr,
  Email,
  "Great! Email successfully sent!": "\xA1Perfecto! Email enviado correctamente",
  hours,
  "Last reservation was XXXXXX hours ago": "La \xFAltima reserva fue hace XXXXXX horas",
  minutes,
  none,
  "Only for registered users": "S\xF3lo para usuarios registrados",
  "Only for specific rates": "S\xF3lo para tarifas espec\xEDficas",
  "Please, provide a valid e-mail": "Por favor, proporcione un correo electr\xF3nico v\xE1lido",
  seconds,
  "Send to booking engine": "Enviar al motor de reservas",
  "Sending search": "Enviando la b\xFAsqueda",
  "Something went wrong. Please, try again later.": "Algo ha ido mal. Por favor, int\xE9ntelo m\xE1s tarde.",
  "Subject to availability": "Sujeto a disponibilidad",
  Terms_default,
  Terms_default_label,
  "Thank you!": "\xA1Gracias!",
  "There are XXXXXX people looking at this hotel right now": "Hay XXXXXX personas mirando este hotel",
  "There has been an error.": "Ha habido un error.",
  "Today's special offer: XXXXXX": "Hoy oferta especial: XXXXXX",
  "View all XXXXXX perks": "Ver todas las ventajas de XXXXXX",
  "We have received your form submission correctly": "Hemos recibido correctamente el env\xEDo de su formulario.",
  "We will send you an email with your search very soon.": "Le enviaremos un correo electr\xF3nico con su b\xFAsqueda muy pronto",
  "Web exclusive": "Exclusivo en web",
  "XXXXXX people have already booked today": "XXXXXX personas ya han reservado este hotel hoy",
  "XXXXXX people have looked at this hotel today": "XXXXXX personas han mirado este hotel hoy",
  "XXXXXX% discount only today": "Hoy, XXXXXX% descuento",
  "You must agree to the Terms & Conditions first": "Primero debes aceptar los T\xE9rminos y Condiciones",
  "Your email": "Tu correo electr\xF3nico",
  "Your email address has been successfully added to our list.": "Tu email ha sido a\xF1adido correctamente."
};
export {
  Back,
  Close,
  Email,
  Terms_default,
  Terms_default_label,
  days,
  days_abbr,
  es as default,
  hours,
  minutes,
  none,
  seconds
};
//# sourceMappingURL=note-p-components-es.js.map
